import _taggedTemplateLiteral from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import React from "react";
import { Composition, Box, useResponsiveProps } from "atomic-layout";
import styled from "styled-components";
export function Row(props) {
  return /*#__PURE__*/React.createElement(Composition, Object.assign({
    templateCols: "repeat(12, 1fr)"
  }, props));
}
var BaseColumn = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tgrid-column: span ", ";\n"])), function (props) {
  return props.cols;
});
export var Column = function Column(props) {
  var _useResponsiveProps = useResponsiveProps(props),
    cols = _useResponsiveProps.cols;
  return /*#__PURE__*/React.createElement(BaseColumn, Object.assign({}, props, {
    cols: cols
  }));
};